app.service('searchService', function ($http) {
  let googleAddressKeys   = ['street_number', 'route', 'neighborhood', 'locality', 'administrative_area_level_2', 'administrative_area_level_1', 'country', 'postal_code', 'postal_code_suffix']
  let googleKeyConversion = ['street_number', 'street_name', 'neighborhood', 'city', 'county', 'state', 'country', 'zip', 'zip_suffix']
  let googleCounties      = []
  let countyCodes         = []
  let countylist          = []
  let searchMethod        = 1

  this.performAnalysis = function (obj) {
    return $http.post('/properties/performAnalysis', obj)
      .then(function (response) {
        return response
      })
  }

  this.getPropUID = function (obj) {
    return $http.post('/properties/getPropUID', obj)
      .then(function (response) {
        return response
      })
  }

  this.getTaxIDs = function (obj) {
    return $http.post('/properties/gettaxids', obj)
      .then(function (response) {
        return response
      })
  }

  this.getStreets = function (obj) {
    return $http.post('/properties/getStreets', obj)
      .then(function (response) {
        return response
      })
  }


  this.setSearchMethod = function(mode)  {
    searchMethod = mode
  }
  this.getSearchMethod = function() {
   return searchMethod
  }

  this.setGoogleCounties = (obj) => {
    countylist     = []
    googleCounties = []
    countyCodes    = []
    obj.map(item => {
      googleCounties.push(item.name)
      countyCodes.push(item.cad_code)
      countylist.push(item.county)
    })
    return countylist.join(", ")
  }

  this.convertGoogleResponseToObject = function (place) {
    var retObj = {}
    var addressInfo = place.address_components
    // Build Address Obj
    for (var a in addressInfo) {
      var keyPosition = googleAddressKeys.indexOf(addressInfo[a].types[0]);
      if (keyPosition > -1) {
        retObj[googleKeyConversion[keyPosition]] = addressInfo[a]
      }
    }
    // Get Formatted Address
    if (place.formatted_address) {
      retObj.formatted_address = place.formatted_address.replace(", USA", "")
    }
    // Get County Code
    if (retObj.county) {
      var cad_code = countyCodes[googleCounties.indexOf(retObj.county.long_name)]
      if (cad_code == undefined) {
        retObj['cad_code'] = '000'
      } else {
        retObj['cad_code'] = String(cad_code)
      }
    } else {
      retObj['cad_code'] = '000'
    }
    return retObj
  }

})
